import { SimpleGrid } from '@mantine/core'
import { QuoteCard } from 'modules/quotes/components'
import { QuoteNode } from 'modules/quotes/types.graphql'

interface UserQuotesProps {
  quotes: QuoteNode[]
}

export const UserQuotes: React.FC<UserQuotesProps> = ({ quotes }) => {
  return (
    <SimpleGrid
      py={'sm'}
      cols={{ base: 1, sm: 2 }}
      spacing={{ base: 'sm', sm: 'md' }}
    >
      {quotes.map(quote => (
        <QuoteCard displaySemester quote={quote} key={quote.id} />
      ))}
    </SimpleGrid>
  )
}
